import React, { useRef } from "react";
import "./index.css";
import { TickIcon } from "../../assets/icons";
import { Upload } from "lucide-react";

const BannerDropzone = ({ onFileSelect, preview, selectedFile, mimetype, existingImageMeta, disabled }) => {
  const fileRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    if (disabled) return;
    const file = e.dataTransfer.files[0];
    if (file) onFileSelect(e, file);
  };

  const handleUpload = (e) => {
    if (disabled) return;
    const file = e.target.files[0];
    if (file) onFileSelect(e, file);
  };

  const isVideo = selectedFile ? selectedFile.type?.startsWith("video/") : mimetype?.startsWith("video/");

  return (
    <div>
      <div className="banner-dropzone w-100 rounded-2 d-flex align-items-center">
        {preview ? (
          <div className="banner-preview-card overflow-hidden d-flex flex-column bg-white">
            <div className="banner-preview-image-container position-relative w-100 overflow-hidden rounded-2">
              {isVideo ? (
                <video
                  src={preview}
                  className="banner-preview-image w-100 rounded-3 h-100 object-fit-cover"
                  controls
                />
              ) : (
                <img
                  src={preview}
                  alt="preview"
                  className="banner-preview-image w-100 rounded-3 h-100 object-fit-cover"
                />
              )}
              {!isVideo && <TickIcon className="banner-check-icon translate-middle top-50 start-50 position-absolute"/>}
            </div>
            <hr style={{ color: "var(--border)" }} className="m-0 my-2" />
            <div>
              <p className=" text-muted file-name">{selectedFile?.name || existingImageMeta?.name || (preview.split('/').pop())}</p>
              {selectedFile && (
                <>
                  <p className="banner-file-size">
                    {(selectedFile.size / 1024 / 1024).toFixed(1)} MB
                  </p>
                </>
              )}
            </div>
            <hr style={{ color: "var(--border)" }} className="m-0 my-1" />

            {!disabled && (
              <button
                type="button"
                className="banner-remove-btn text-muted w-100 border-0 bg-transparent cursor-pointer"
                onClick={(e) => {
                  onFileSelect(e, null);
                }}
              >
                Remove File
              </button>
            )}
          </div>
        ) : (
          <div className="banner-dropzone-content text-center">
           
            <button className="text-secondary rounded-1 upload-icon border-0" onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
              onClick={() => !disabled && fileRef.current.click()}
              disabled={disabled}>
              <Upload size={24}/>
            </button>
            <p className="drop-title fw-semibold m-0">
              Drop files here or click to upload
            </p>
            <p className="drop-subtitle text-muted">
              You can drag images, videos, or GIFs here.
            </p>
          </div>
        )}
      </div>

      <input
        type="file"
        accept="image/*,video/*"
        ref={fileRef}
        className="d-none"
        onChange={handleUpload}
      />
    </div>
  );
};

export default BannerDropzone;
